import { CacheRequestState, RequestState } from '../models/RequestState';
import InstanceClient from '../services/InstanceClient';
import StatusCode from '../util/StatusCode';
import { Dispatch } from 'react';
import { Action, Reducer } from 'redux';
import { AuditLogEvent, CoreAuditLogEntry } from '../models/CoreAuditLogEntry';
import { PageResult } from '../models/CoreModels';
import { AuditLogSearchPageRequest } from '../models/Requests';

enum AuditLogType {
    LIST_AUDITLOG = 'LIST_AUDITLOG',
    LIST_AUDITLOG_UPDATE = 'LIST_AUDITLOG_UPDATE',
    LIST_EVENT_TYPES = 'LIST_EVENT_TYPES',
};

export interface AuditLogState {
    auditLogs: CacheRequestState<PageResult<CoreAuditLogEntry>>
    eventTypes: RequestState<AuditLogEvent[]>
}

interface AuditLog_List extends Action<AuditLogType> {
    type: AuditLogType.LIST_AUDITLOG,
    auditLogs: CacheRequestState<PageResult<CoreAuditLogEntry>>
}

interface AuditLog_List_Update extends Action<AuditLogType> {
    type: AuditLogType.LIST_AUDITLOG_UPDATE,
}

interface AuditLog_EventTypes extends Action<AuditLogType> {
    type: AuditLogType.LIST_EVENT_TYPES,
    eventTypes: RequestState<AuditLogEvent[]>
}

type ListAuditLogs = AuditLog_List
    | AuditLog_List_Update;

type AuditLogAction = ListAuditLogs | AuditLog_EventTypes;


export const ListAuditLog = (filter: Partial<AuditLogSearchPageRequest> = {}, update: boolean) => (dispatch: Dispatch<ListAuditLogs>) => {
    if (update) {
        dispatch({ type: AuditLogType.LIST_AUDITLOG, auditLogs: { code: StatusCode.PENDING } });
    } else {
        dispatch({ type: AuditLogType.LIST_AUDITLOG_UPDATE });
    }

    InstanceClient.get<PageResult<CoreAuditLogEntry>>('/api/core/auditLog', filter)
        .then(res =>
            dispatch({
                type: AuditLogType.LIST_AUDITLOG,
                auditLogs: { code: StatusCode.COMPLETE, data: res.data }
            })
        )
        .catch(error =>
            dispatch({
                type: AuditLogType.LIST_AUDITLOG,
                auditLogs: { code: StatusCode.ERROR, error }
            }));
};


export const ListAuditLogEventTypes = () => (dispatch: Dispatch<AuditLog_EventTypes> ) => {
    dispatch({
        type: AuditLogType.LIST_EVENT_TYPES,
        eventTypes: { code: StatusCode.PENDING }
    });

    InstanceClient.get<AuditLogEvent[]>('/api/core/auditLog/eventTypes')
        .then(res => 
            dispatch({
                type: AuditLogType.LIST_EVENT_TYPES,
                eventTypes: { code: StatusCode.COMPLETE, data: res.data }
            })
        )
        .catch(error =>
            dispatch({
                type: AuditLogType.LIST_EVENT_TYPES,
                eventTypes: { code: StatusCode.ERROR, error }
            }));
}


const initialState: AuditLogState = {
    auditLogs: { code: StatusCode.NONE, },
    eventTypes: { code: StatusCode.NONE, },
};

export const reducer: Reducer<AuditLogState, AuditLogAction> = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case AuditLogType.LIST_AUDITLOG:
            return {
                ...state,
                auditLogs: action.auditLogs,
            };
        case AuditLogType.LIST_AUDITLOG_UPDATE:
            return {
                ...state,
                auditLogs: { ...state.auditLogs, code: StatusCode.PENDING },
            };
        case AuditLogType.LIST_EVENT_TYPES:
            return {
                ...state,
                eventTypes: action.eventTypes,
            };
        default:
            return state;
    }
}

